export const columnWidths = {
  type: '66%',
  status: '24%',
  isSubmitted: '8%',
};
